/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemStatus model module.
 * @module model/SystemStatus
 * @version 1.1.0
 */
class SystemStatus {
    /**
     * Constructs a new <code>SystemStatus</code>.
     * The decomposed operational status of the Fire Controller
     * @alias module:model/SystemStatus
     * @param systemMode {module:model/SystemStatus.SystemModeEnum} Whether a human operator (MANUAL) or the AI (AUTO) controls activations
     * @param sharedMode {module:model/SystemStatus.SharedModeEnum} Overall activation lifecycle state
     * @param specialMode {module:model/SystemStatus.SpecialModeEnum} Active sub-state modifier; NONE when no special mode is active
     */
    constructor(systemMode, sharedMode, specialMode) { 
        
        SystemStatus.initialize(this, systemMode, sharedMode, specialMode);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, systemMode, sharedMode, specialMode) { 
        obj['systemMode'] = systemMode;
        obj['sharedMode'] = sharedMode;
        obj['specialMode'] = specialMode;
    }

    /**
     * Constructs a <code>SystemStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemStatus} obj Optional instance to populate.
     * @return {module:model/SystemStatus} The populated <code>SystemStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemStatus();

            if (data.hasOwnProperty('systemMode')) {
                obj['systemMode'] = ApiClient.convertToType(data['systemMode'], 'String');
            }
            if (data.hasOwnProperty('sharedMode')) {
                obj['sharedMode'] = ApiClient.convertToType(data['sharedMode'], 'String');
            }
            if (data.hasOwnProperty('specialMode')) {
                obj['specialMode'] = ApiClient.convertToType(data['specialMode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemStatus</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemStatus</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemStatus.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['systemMode'] && !(typeof data['systemMode'] === 'string' || data['systemMode'] instanceof String)) {
            throw new Error("Expected the field `systemMode` to be a primitive type in the JSON string but got " + data['systemMode']);
        }
        // ensure the json data is a string
        if (data['sharedMode'] && !(typeof data['sharedMode'] === 'string' || data['sharedMode'] instanceof String)) {
            throw new Error("Expected the field `sharedMode` to be a primitive type in the JSON string but got " + data['sharedMode']);
        }
        // ensure the json data is a string
        if (data['specialMode'] && !(typeof data['specialMode'] === 'string' || data['specialMode'] instanceof String)) {
            throw new Error("Expected the field `specialMode` to be a primitive type in the JSON string but got " + data['specialMode']);
        }

        return true;
    }


}

SystemStatus.RequiredProperties = ["systemMode", "sharedMode", "specialMode"];

/**
 * Whether a human operator (MANUAL) or the AI (AUTO) controls activations
 * @member {module:model/SystemStatus.SystemModeEnum} systemMode
 */
SystemStatus.prototype['systemMode'] = undefined;

/**
 * Overall activation lifecycle state
 * @member {module:model/SystemStatus.SharedModeEnum} sharedMode
 */
SystemStatus.prototype['sharedMode'] = undefined;

/**
 * Active sub-state modifier; NONE when no special mode is active
 * @member {module:model/SystemStatus.SpecialModeEnum} specialMode
 */
SystemStatus.prototype['specialMode'] = undefined;





/**
 * Allowed values for the <code>systemMode</code> property.
 * @enum {String}
 * @readonly
 */
SystemStatus['SystemModeEnum'] = {

    /**
     * value: "MANUAL"
     * @const
     */
    "MANUAL": "MANUAL",

    /**
     * value: "AUTO"
     * @const
     */
    "AUTO": "AUTO"
};


/**
 * Allowed values for the <code>sharedMode</code> property.
 * @enum {String}
 * @readonly
 */
SystemStatus['SharedModeEnum'] = {

    /**
     * value: "UNINITIALIZED"
     * @const
     */
    "UNINITIALIZED": "UNINITIALIZED",

    /**
     * value: "PRIMING"
     * @const
     */
    "PRIMING": "PRIMING",

    /**
     * value: "DEACTIVATING"
     * @const
     */
    "DEACTIVATING": "DEACTIVATING",

    /**
     * value: "ACTIVATING"
     * @const
     */
    "ACTIVATING": "ACTIVATING",

    /**
     * value: "ON"
     * @const
     */
    "ON": "ON",

    /**
     * value: "OFF"
     * @const
     */
    "OFF": "OFF",

    /**
     * value: "ERROR"
     * @const
     */
    "ERROR": "ERROR"
};


/**
 * Allowed values for the <code>specialMode</code> property.
 * @enum {String}
 * @readonly
 */
SystemStatus['SpecialModeEnum'] = {

    /**
     * value: "NONE"
     * @const
     */
    "NONE": "NONE",

    /**
     * value: "PRESOAKING"
     * @const
     */
    "PRESOAKING": "PRESOAKING",

    /**
     * value: "COLLABORATIVE_SOAK"
     * @const
     */
    "COLLABORATIVE_SOAK": "COLLABORATIVE_SOAK",

    /**
     * value: "NON_EMERGENCY_COOLDOWN"
     * @const
     */
    "NON_EMERGENCY_COOLDOWN": "NON_EMERGENCY_COOLDOWN"
};



export default SystemStatus;

